import React from 'react';
import styled from 'styled-components';

const AuthInput = (props: Props) => {
	const { index, value, onInput, onFocus, onPaste, onBackspace, isDisabled } = props;
	const ref = React.useRef<HTMLInputElement>(null);
	React.useEffect(() => {
		requestAnimationFrame(() => {
			if (ref.current !== document.activeElement && props.isFocused) {
				ref?.current?.focus();
			}
		});
	}, [props.isFocused]);

	const handleChange = (e) => {
		if (e.target.value) onInput(index, e.target.value);
	};

	const handlePaste = (e) => {
		onPaste(e.clipboardData.getData('text'));
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Backspace') {
			onBackspace();
		}
	};

	const handleFocus = (e) => {
		e.target.setSelectionRange(0, 1);
		onFocus(index);
	};
	// ! This input needs to be of type "text", but we want to show the numeric keyboard on mobile, ergo the inputMode and pattern attributes.
	// ! It needs to be text for the above events to work as expected.
	return (
		<Input
			ref={ref}
			type="text"
			value={value}
			onChange={handleChange}
			onPaste={handlePaste}
			onKeyDown={handleKeyDown}
			maxLength={1}
			onFocus={handleFocus}
			disabled={isDisabled}
			inputMode="numeric"
			pattern="[0-9]*"
		/>
	);
};

interface Props {
	index: number;
	value: string;
	onInput: (index: number, value: string) => void;
	onFocus: (index: number) => void;
	onPaste: (value: string) => void;
	onBackspace: () => void;
	isFocused: boolean;
	isDisabled: boolean;
}

export default AuthInput;

const Input = styled.input`
	border: 2px solid grey;
	border-radius: 4px;
	width: 100%;
	padding: 20px 0;
	text-align: center;
	font-size: 20px;
	line-height: 1;
	box-sizing: border-box;
	:focus {
		border-color: blue;
	}
`;
